module.exports = __webpack_public_path__ + "static/media/app-store-es.2c657046.svg";